// src/app/features/auth/components/company-registration-form-view.tsx
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import CompanyFieldView from "./company-field-view"; // Import the CompanyFieldView component
import CompanySubmitView from "./company-submit-view"; // Import the CompanySubmitView component
//import {useNavigate} from "react-router-dom";
import { z } from "zod";
import { Form } from "@/app/global-components/form";
import { useEffect, useState } from "react";
import regionsData from "@/app/features/company/data/regions_lite.json";
import citiesData from "@/app/features/company/data/cities_lite.json";
import { Separator } from "@/app/global-components/separator";
import { RootState } from "@/store/type";
import { useSelector } from "react-redux";
import { isNull } from "lodash";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG, ROLE } from "@/types";
import useRegisterCompany from "@/hooks/use-register-company";
import { createCompanySchema } from "@/schema";

// import { CategoryOption } from "@/pages/seller/articles";
// import useOffer from "@/hooks/useTender";
//import { Button } from "@mui/material";

interface Region {
  region_id: number;
  name_ar: string;
}

interface City {
  city_id: number;
  region_id: number;
  name_ar: string;
}

interface Option {
  value: string;
  label: string;
}

const CompanyFormView = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const CompanySchema = createCompanySchema(t as (key: string) => string);
  const { registerCompany,updateCompany, isSaveLoading, error } = useRegisterCompany();
  const [showStampedAuthorizationForm, setShowStampedAuthorizationForm] =
    useState<boolean>(false);
  const [regions, setRegions] = useState<Option[]>([]);
  const [cities, setCities] = useState<Option[]>([]);
  const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const form = useForm<z.infer<typeof CompanySchema>>({
    resolver: zodResolver(CompanySchema),
    defaultValues: {
      nameAr: "",
      nameEn: "",
      website: "",
      address: "",
      region: "",
      city: "",
      registrationNumber: "",
      ownerType: "Owner", // Default value
      stampedAuthorizationFormUrl: null,
      plaseOfIssue: "",
      turnover: 0,
      type: "",
      activities: "",
      categories: "",
      creationDate: "", // Change default value to null
      registrationExpirationDate: "",
    },
  });
  // const [Categoris, setCategoris] = useState<CategoryOption[]>([]);
  // const { getcategories } = useOffer();
  // useEffect(() => {
  //   const fetching = async () => {
  //     const Categories = await getcategories();
  //     if (Categories) {
  //       const uniqueCategories = Categories.data.filter(
  //         (item: { name: any }, index: any, self: any[]) =>
  //           index === self.findIndex((t) => t.name === item.name)
  //       );
  //       const Cates: CategoryOption[] = uniqueCategories.map(
  //         (item: { id: any; name: any }) => ({
  //           value: item.id,
  //           label: item.name,
  //         })
  //       );
  //       setCategoris(Cates);
  //     } else {
  //       setCategoris([]);
  //     }
  //   };
  //   fetching();
  // }, []);
  // const [filterCategories, setFilterCategories] = useState<string>();
  // useEffect(() => {
  //   if (filterCategories) {
  //     form.setValue("categories", filterCategories);
  //   }
  // }, [filterCategories]);
  useEffect(() => {
    if (!isNull(myCompany)) {
      form.reset({
        ...form.getValues(),
        ...myCompany,
        region: myCompany?.region?.toString() || "",
        city: myCompany?.city?.toString() || "",
      });
    }
  }, [myCompany]);
  const { watch } = form;
  const ownerType = watch("ownerType");

  useEffect(() => {
    setRegions(
      regionsData.map((region: Region) => ({
        value: region.region_id.toString(), // Convert to string
        label: region.name_ar,
      }))
    );
  }, []);

  useEffect(() => {
    const selectedRegion = form.watch("region");
    if (selectedRegion) {
      const filteredCities = citiesData
        .filter((city: City) => city.region_id === parseInt(selectedRegion))
        .map((city: City) => ({
          value: city.city_id.toString(),
          label: city.name_ar,
        }));
      setCities(filteredCities);
    } else {
      setCities([]);
    }
  }, [form.watch("region")]);

  const onSubmit = async (values: z.infer<typeof CompanySchema>) => {
    try {
      const formData = new FormData();

      // Append all text fields
      const data = Object.entries(values).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      );
      for (const [key, value] of data) {
        if (
          key !== "authorizationFile" &&
          key !== "registeringFile" &&
          key !== "logoMedia"
        ) {
          formData.append(key, String(value) || ""); // Append other fields as string
        }
      }

      // Append files if they are not null
      if (values.authorizationFile instanceof File) {
        formData.append("authorizationFile", values.authorizationFile);
      }

      if (values.registeringFile instanceof File) {
        formData.append("registeringFile", values.registeringFile);
      }

      if (values.logoMedia instanceof File) {
        formData.append("logoMedia", values.logoMedia);
      }

      // Debug: Log FormData content
      // for (const pair of formData.entries()) {
      // }

      // Send the FormData using your API hook
      if (myCompany?.userId) {
        await updateCompany(formData, myCompany.id);
      } else {
        await registerCompany(formData);
      }
    } catch (err) {
      console.error("Error during registration:", err);
    }
  };
 console.log('f',form.formState.errors)
  useEffect(() => {
    if (ownerType === "Authorized") {
      setShowStampedAuthorizationForm(true);
    } else {
      setShowStampedAuthorizationForm(false);
    }
  }, [ownerType]);
  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-4 bg-white md:h-[calc(90vh-90px)] rounded-2xl p-5 overflow-scroll no-scrollbar"
      >
        <div className="grid grid-cols-2 gap-4">
          <CompanyFieldView
            name="nameAr"
            dir={locale === LANG.AR ? "rtl" : "ltr"}
            label={`${t("company.fields.name")}*`}
            placeholder={t("company.placeholders.chooseName")}
            formControl={form.control}
          />

          <CompanyFieldView
            name="nameEn"
            dir={locale === LANG.AR ? "rtl" : "ltr"}
            label={`${t("company.fields.nameEn")}*`}
            placeholder={t("company.placeholders.enterNameEn")}
            formControl={form.control}
          />
        </div>
        <CompanyFieldView
          name="website"
          dir={locale === LANG.AR ? "rtl" : "ltr"}
          label={t("company.fields.website")}
          placeholder={t("company.placeholders.enterWebsite")}
          formControl={form.control}
          inputType="text"
        />
        <Separator className="w-full bg-primary-gray h-[2px]" />
        <CompanyFieldView
          dir={locale === LANG.AR ? "rtl" : "ltr"}
          name="address"
          label={t("company.fields.address")}
          placeholder={t("company.placeholders.enterAddress")}
          formControl={form.control}
        />
        <CompanyFieldView
          dir={locale === LANG.AR ? "rtl" : "ltr"}
          name="deliveryAddress"
          label={t("company.fields.deliveryAddress")}
          placeholder={t("company.placeholders.enterDeliveryAddress")}
          formControl={form.control}
        />
        <div className="flex flex-col mt-2 sm:flex-row justify-between sm:items-center xs:gap-5 sm:gap-20 w-full">
          <section className=" sm:w-1/2 w-full flex flex-col">
            <CompanyFieldView
              name="region"
              label={t("company.placeholders.selectRegion")+'*'}
              placeholder=""
              inputType="combobox"
              options={regions}
              formControl={form.control}
            />
          </section>
          <section className="flex flex-col sm:w-1/2 w-full">
            <CompanyFieldView
              name="city"
              label={t("company.placeholders.selectCity")}
              placeholder={t("company.placeholders.selectCity")+'*'}
              inputType="combobox"
              options={cities}
              formControl={form.control}
            />
          </section>
        </div>
        <Separator className="w-full bg-primary-gray h-[2px] " />
        <div className="sm:flex sm:flex-row xs:gap-5 justify-between items-center">
          <section className="sm:w-1/4 w-full flex items-center">
            <CompanyFieldView
              name="ownerType"
              label={t("company.fields.ownerType")}
              placeholder={t("company.fields.ownerType")}
              inputType="radio"
              options={[
                { value: "Owner", label: t("company.fields.owner") },
                { value: "Authorized", label: t("company.fields.authorized") },
              ]}
              formControl={form.control}
            />
          </section>
          {showStampedAuthorizationForm && (
            <>
              <section className="sm:w-1/4 w-full">
                <CompanyFieldView
                  name="stampedAuthorizationFormUrl"
                  label={t("company.fields.authorizationFormId")}
                  placeholder={t("company.placeholders.enterAuthorizationId")}
                  formControl={form.control}
                />
              </section>
              <section className="sm:w-1/4 w-full">
                <CompanyFieldView
                  name="authorizationFile"
                  label={t("company.fields.authorizationFile")}
                  placeholder={t(
                    "company.placeholders.chooseAuthorizationFile"
                  )}
                  inputType="Attachment"
                  formControl={form.control}
                />
              </section>
            </>
          )}
        </div>
        <Separator className="w-full bg-primary-gray h-[2px] " />
        <div className="sm:flex sm:flex-row xs:gap-5 justify-between items-center">
          <section className="sm:w-1/4 w-full">
            <CompanyFieldView
              name="registrationNumber"
              dir={locale === LANG.AR ? "rtl" : "ltr"}
              label={`${t("company.fields.commercialRegistration")}*`}
              placeholder={t("company.placeholders.enterCommercialRegNumber")}
              formControl={form.control}
            />
          </section>
          <section className="sm:w-1/4 w-full">
            <CompanyFieldView
              name="registeringFile"
              label={t("company.fields.registrationFile")}
              placeholder={t("company.placeholders.chooseCommercialRegFile")}
              inputType="Attachment"
              formControl={form.control}
            />
          </section>
          <section className="sm:w-1/4 w-full">
            <CompanyFieldView
              name="taxInformation"
              dir={locale === LANG.AR ? "rtl" : "ltr"}
              label={`${t("company.fields.taxInfo")}*`}
              placeholder={t("company.placeholders.enterTaxInfo")}
              formControl={form.control}
            />
          </section>
        </div>
        <div className="sm:flex sm:flex-row xs:gap-5 justify-between items-center">
          <section className="sm:w-1/4 w-full">
            <CompanyFieldView
              name="plaseOfIssue"
              dir={locale === LANG.AR ? "rtl" : "ltr"}
              label={t("company.fields.placeOfIssue")}
              placeholder={t("company.placeholders.enterIssuePlace")}
              formControl={form.control}
            />
          </section>
          <section className="sm:w-1/4 w-full">
            <CompanyFieldView
              name="creationDate"
              label={t("company.fields.registrationDate")}
              placeholder={t("company.placeholders.enterRegistrationDate")}
              inputType="date"
              formControl={form.control}
            />
          </section>
          <section className="sm:w-1/4 w-full">
            <CompanyFieldView
              name="registrationExpirationDate"
              label={t("company.fields.expiryDate")}
              placeholder={t("company.placeholders.enterExpiryDate")}
              inputType="date"
              formControl={form.control}
            />
          </section>
        </div>
        <Separator className="w-full bg-primary-gray h-[2px]" />
        <div>{t("company.info")}</div>
        <div className="sm:flex sm:flex-row justify-between items-center">
          <section className="sm:w-1/4 w-full flex items-center">
            <CompanyFieldView
              name="turnover"
              label={
                authUser.role === ROLE.SELLER
                  ? t("company.fields.annualSales")
                  : t("company.fields.annualPurchases")
              }
              placeholder={
                authUser.role === ROLE.SELLER
                  ? t("company.placeholders.enterAnnualSales")
                  : t("company.placeholders.enterAnnualPurchases")
              }
              dir={locale === LANG.AR ? "rtl" : "ltr"}
              formControl={form.control}
            />
          </section>
          <section className="sm:w-1/4 w-full flex items-center">
            <CompanyFieldView
              name="employeesNumber"
              dir={locale === LANG.AR ? "rtl" : "ltr"}
              label={t("company.fields.employeesNumber")}
              placeholder={t("company.placeholders.enterEmployeeCount")}
              formControl={form.control}
            />
          </section>
        </div>
        <div className="sm:flex sm:flex-row items-center  xs:gap-10">
          <section className="w-full">
            <CompanyFieldView
              name="categories"
              label={t("company.fields.categories")}
              placeholder={t("company.placeholders.enterCategories")}
              inputType="textarea"
              formControl={form.control}
            />
            <label className="block text-sm font-medium">
              {t("item.fields.categories")}
            </label>
            {/* <Select
              displayEmpty
              id="categorie-multiple-name"
              input={<OutlinedInput />}
              inputProps={{ "aria-label": "Without label" }}
              className="h-10 mt-2 bg-background w-36 md:w-64 xl:w-80 border !border-zinc-500"
              sx={{
                "& .MuiSelect-select": {
                  paddingRight: "10px !important",
                },
                "& .MuiSelect-icon": {
                  left: locale === LANG.EN ? "unset" : 0,
                  marginLeft: 0,
                  right: locale === LANG.EN ? 0 : "unset",
                },
              }}
             
              value={filterCategories}
              onChange={(e) => {
                setFilterCategories(e.target.value);
              }}
              MenuProps={MenuProps}
            >
              <MenuItem disabled value="">
                <em>{t("categories.select")}</em>
              </MenuItem>
              {Categoris.map((name) => (
                <MenuItem
                  className="!mb-2"
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: "#000",
                      borderRadius: 15,
                      color: "#fff",
                      fontWeight: "600",
                    },
                    "&:hover.MuiMenuItem-root": {
                      backgroundColor: "#000",
                      borderRadius: 15,
                      color: "#fff",
                    },
                  }}
                  key={name.value}
                  value={name.value}
                  // style={getStyles(name, personName, theme)}
                >
                  <span>{name.label}</span>
                </MenuItem>
              ))}
            </Select> */}
          </section>
          <section className="w-full">
            <CompanyFieldView
              name="activities"
              label={t("company.fields.activities")}
              placeholder={t("company.placeholders.enterActivities")}
              inputType="textarea"
              formControl={form.control}
            />
          </section>
        </div>
        <Separator className="w-full bg-primary-gray h-[2px] " />
        <div className="sm:flex sm:flex-row items-center  xs:gap-10">
          <section className="w-1/5">
            <CompanyFieldView
              name="logoMedia"
              label={t("company.fields.logo")}
              placeholder={t("company.placeholders.chooseLogo")}
              inputType="file"
              formControl={form.control}
              defaultImage={myCompany?.logoMedia || ""}
            />
          </section>
        </div>
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

        <div className="flex justify-end">
          <CompanySubmitView isLoading={isSaveLoading} />
          {/*
          <Button
            type="submit"
            variant="contained"
            className="!bg-black !text-white font-bold !px-10 !py-2"
          >
            {t("actions.save")}
          </Button>
          */}
        </div>
      </form>
    </Form>
  );
};

export default CompanyFormView;
